import { number, object, string } from 'yup';

import client from '$app-web/core/client';

const requestSchema = object().shape({
    reg_code: number().required(),
    device_id: string().required(),
});

const useJoinStudyEndpoint = client.registerEndpoint('POST api/join-study', `/study/registration/create/`, {
    requestSchema,
    mutate: true,
});

export default useJoinStudyEndpoint;
